"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPaginationSqlQuery = void 0;
const getPaginationSqlQuery = (query) => {
    if (!query.hasOwnProperty('limit') || !query.hasOwnProperty('page')) {
        return '';
    }
    const page = (query.page - 1) * query.limit;
    return `LIMIT ${query.limit} OFFSET ${page}`;
};
exports.getPaginationSqlQuery = getPaginationSqlQuery;
